<template>
  <PageTable />
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'ecom-awsBiz-skuFirstOrderPurchase',
  components: { PageTable },
}
</script>
